import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import New from '@/components/screens/new/New';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IBooksPage } from '@/interfaces/booksPage.interface';

const NewPageDynamic: NextPage<IBooksPage> = ({ books }) => {
  useRedirectToFirstPage('/new');
  return <New books={books} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const res = await fetch(`${API_URL}satellite/books/news?page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}`);
  const books = await res.json();

  // Check Fetched Data
  if (books?.data.length === 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default NewPageDynamic;
